import React from 'react';
import StatusTag from './StatusTag';
import { IShipment } from '/imports/api/shipments/interfaces/Shipment';

interface IShipmentStatusTagProps {
  status: IShipment["status"];
}

const STATUS_COLORS = {
  "draft": "red",
  "partial": "yellow",
  "planned": "orange",
  "scheduled": "orange",
  "started": "blue",
  "completed": "green",
  "canceled": "grey"
}

const ShipmentStatusTag: React.FunctionComponent<IShipmentStatusTagProps> = ({ status }) => {
  return <StatusTag color={STATUS_COLORS[status] || "orange"} text={status} />;
};

export default ShipmentStatusTag;
